import React from "react";
import { Link } from "react-router-dom";

function AuthFooter() {
  return (
    <footer className="auth-footer">
      <div className="auth-footer-inner">
        <div className="auth-footer-links">
          <Link to="/vendor#how-it-works">How It Works</Link>
          <Link to="/vendor#pricing">Pricing</Link>
          <Link to="/vendor/requirements">Seller Requirements</Link>
          <Link to="/vendor#faq">FAQ</Link>
          <a href="mailto:support@imonline.shop">Seller Support</a>
          <a href="https://www.imonline.shop" target="_blank" rel="noreferrer">
            Customer Website &#x2197;
          </a>
        </div>
        <div className="auth-footer-copyright">
          &copy; {new Date().getFullYear()} IM Online. All rights reserved. Built for Indian sellers.
        </div>
      </div>
    </footer>
  );
}

export default AuthFooter;
